import type { NodeMock, StatePreset } from "../mock-types";

export const voiceChannelJoinMock: NodeMock = {
  label: "Voice Channel Join",
  description: "Players join the voice channel",
  state: (players) => ({
    channelId: "vc_123",
    channelName: "Match Lobby",
    joinedPlayers: [players[0]?.userId, players[1]?.userId].filter(Boolean),
    failedPlayers: [],
    noDiscord: false,
  }),
  config: {
    timeoutSeconds: 30,
    channelName: "Match #{{matchId}}",
    autoMove: true,
    requireConfirmation: false,
    labels: {
      title: "Voice Channel",
      subtitle: "Gathering players in voice",
    },
  },
};

export const voiceChannelJoinPresets: StatePreset[] = [
  {
    label: "None Joined",
    build: ({ defaultState }) => ({
      state: { ...defaultState, joinedPlayers: [], failedPlayers: [] },
    }),
  },
  {
    label: "Some Joined",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        joinedPlayers: players.slice(0, Math.ceil(players.length / 2)).map((p) => p.userId),
        failedPlayers: [],
      },
    }),
  },
  {
    label: "All Joined",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, joinedPlayers: players.map((p) => p.userId), failedPlayers: [] },
    }),
  },
  {
    label: "With Failures",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        joinedPlayers: players.slice(0, Math.max(1, players.length - 2)).map((p) => p.userId),
        failedPlayers: players.slice(-2).map((p) => p.userId),
      },
    }),
  },
];
